import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';
import Dashboard from './components/Dashboard';
import PromptCustomization from './components/PromptCustomization';
import Customer from './components/Customer';
import Settings from './components/Settings';
import CustomerDetail from './components/CustomerDetail';
import Discovery from './components/Discovery';
import Reports from './components/Reports';
import Testing from './components/Testing';
import Feedback from './components/Feedback';
import Login from './components/Login';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from './context/AppContext';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if user is already logged in (from localStorage)
    const token = localStorage.getItem('admin_token');
    if (token) {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, []);

  const handleLogin = (token) => {
    localStorage.setItem('admin_token', token);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    setIsAuthenticated(false);
  };

  if (isLoading) {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      }}>
        <Box sx={{ 
          textAlign: 'center', 
          color: 'white',
          animation: 'pulse 2s infinite'
        }}>
          <Box sx={{ 
            width: 60, 
            height: 60, 
            borderRadius: '50%', 
            background: 'rgba(255,255,255,0.2)', 
            margin: '0 auto 20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <Box sx={{ 
              width: 40, 
              height: 40, 
              borderRadius: '50%', 
              background: 'white',
              animation: 'spin 1s linear infinite'
            }} />
          </Box>
          <Box sx={{ fontSize: 18, fontWeight: 500 }}>Loading...</Box>
        </Box>
      </Box>
    );
  }

  return (
    <AppProvider>
      <Router>
        {isAuthenticated ? (
          <Box sx={{ display: 'flex', minHeight: '100vh', background: '#f5f6fa' }}>
            <CssBaseline />
            <Sidebar onLogout={handleLogout} />
            <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
              <Topbar />
              <Routes>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/customers" element={<Customer />} />
                <Route path="/discovery" element={<Discovery />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/testing" element={<Testing />} />
                <Route path="/prompt-customization" element={<PromptCustomization />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/feedback" element={<Feedback />} />
                <Route path="/customer/:user_id" element={<CustomerDetail />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </Box>
          </Box>
        ) : (
          <Routes>
            <Route path="/login" element={<Login onLogin={handleLogin} />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        )}
      </Router>
    </AppProvider>
  );
}

export default App;
